import { Alert, Button, Snackbar } from "@mui/material";
import { useEffect, useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useNotification } from "../../store/notification-context";

const AUTO_HIDE_DURATION = 6000;
const NOTIFICATION_SOUND_SRC = "/notification-toast.mp3";

const NotificationHost = () => {
    const { activeNotification, closeNotification } = useNotification();
    const audioRef = useRef(null);

    useEffect(() => {
        if (typeof Audio === 'undefined') {
            return;
        }

        audioRef.current = new Audio(NOTIFICATION_SOUND_SRC);
        audioRef.current.preload = 'auto';

        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (!activeNotification || !audioRef.current) {
            return;
        }

        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(() => {
            // Ignore autoplay failures; the toast still appears.
        });
    }, [activeNotification]);

    const handleClose = (_, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        closeNotification();
    };

    const action = activeNotification?.fileId ? (
        <Button
            color="inherit"
            size="small"
            component={RouterLink}
            to={`/files/${activeNotification.fileId}`}
            onClick={closeNotification}
        >
            Apri file
        </Button>
    ) : activeNotification?.actionTo ? (
        <Button
            color="inherit"
            size="small"
            component={RouterLink}
            to={activeNotification.actionTo}
            onClick={closeNotification}
        >
            {activeNotification.actionLabel || 'Apri'}
        </Button>
    ) : null;

    return (
        <Snackbar
            open={Boolean(activeNotification)}
            autoHideDuration={AUTO_HIDE_DURATION}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            <Alert
                onClose={handleClose}
                severity={activeNotification?.severity || "success"}
                variant="filled"
                action={action}
                sx={{ width: '100%', alignItems: 'center' }}
            >
                {activeNotification?.title ? `${activeNotification.title}. ${activeNotification.message}` : activeNotification?.message}
            </Alert>
        </Snackbar>
    );
};

export default NotificationHost;
